/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { decodeToken } from "../../utils/commonFunctions";
import {
  InitializeConversationHistory, SaveConversationHistory,
  GetConversationHistory, MessageUpdate, generateTitle, TitleUpdate
  // getUnitPlanResponse
} from "../../utils/Chatapi";
// import { getUpdatedLessonState } from "../../utils/UnitChatGpt";
import { useChatContext } from "../../context/ChatContext";
import OuterPage from "../Home/OuterPage";
import { useLocation } from "react-router-dom";
import {
  christianEducation,
  copyData,
  isFinalPlanMessage,
  savePlanDocToSession,
  loadPlanDocFromSession,
  downloadPlanDocxFromBase64,
  fetchPlanDocxFromText,
  stripDocSeparatorLines,
} from '../../utils/Chatapi';
import {
  ensureGoogleDriveAccessToken,
  getGoogleDriveClientStatus,
  isGoogleDriveClientConfigured,
  uploadDocxToGoogleDrive,
} from "../../utils/googleDriveClient";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { buildLearningSupportSidebarTitle } from "../../utils/learningSupportSidebarTitle";

import { useParams, useSearchParams } from "react-router-dom";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";


const AfterChatbot = () => {
  const navigate = useNavigate();
  const location = useLocation();
      const { signupData } = React.useContext(SchoolSignupContext);
  const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");
  
  const [BotTyping, setBotTyping] = useState(false);
  const fromTFT = location.state?.fromTFT === true;
  const [loaderText, setLoaderText] = useState(!fromTFT);
  const [stopReload, setStopReload] = useState(true)

  const formatedatatft = {
    [location?.state?.input]: location?.state?.input
  };
  const predefinedAnswersRef = useRef(
    (location?.state?.answers && Object.keys(location.state.answers).length > 0)
      ? location.state.answers
      : (location?.state?.input ? formatedatatft : {})
  );
  const predefinedAnswers = predefinedAnswersRef.current;
  const [chatLoading, setChatLoading] = useState(false)
  const [message, setMessage] = useState("");
  const [allMessage, setAllMessage] = useState([]);
  const [allAttachments, setAllAttachments] = useState([]);

  const [planDocReady, setPlanDocReady] = useState(false);
  const [planDocMeta, setPlanDocMeta] = useState(null);
  const [finalPlanMessageIndex, setFinalPlanMessageIndex] = useState(-1);
  const [isStreamingResponse, setIsStreamingResponse] = useState(false);
  const planDocShownRef = useRef(false);
  const prevConversationIdRef = useRef(null);
  const initInProgressRef = useRef(false);
  const [googleSaving, setGoogleSaving] = useState(false);
  const [googleDriveConnected, setGoogleDriveConnected] = useState(false);
  const [googleDriveEmail, setGoogleDriveEmail] = useState("");

  const [visibleMsgBox, setVisibleMsgBox] = useState(true);
  
  const { titleId, setTitleId, setSidelistUpdate, conversationHistory } = useChatContext();


  let userTokenData = decodeToken();
  let userId = userTokenData?.user_id; // Store user_id in a separate variable

  const { id: idFromParams, types, historySize } = useParams();
  const [searchParams] = useSearchParams();
  const id = idFromParams ?? searchParams.get("id");
  const linkMasterTypeId = searchParams.get("masterTypeId");
  const isSharedLink = id && linkMasterTypeId !== null && linkMasterTypeId !== "";
  const currentUserMasterTypeId = userTokenData?.masterTypeid ?? signupData?.schoolType ?? "";
  // console.log(id,"idfromparam")
  // console.log(types,"typesfromparam")
  // console.log(historySize,"historySizefromparam")
  const { initialStart, setCheckType, setShareSize, highLightBtn, setHighLightBtn } = useChatContext();

  // console.log(initialStart, "initialStart11")
  // console.log(types, "typesfromparam")

  const [type, setType] = useState(initialStart === "UnitPlanning" ? "unit" : initialStart === "LessonPlanning" ? "lesson" : initialStart === "Assessment" ? "assessment" :
    initialStart === "tft"
      ? "tft"
      : initialStart === "tftc"
        ? "tftc" : initialStart === "LearningSupports" ? "learningSupports" : types ? types : "")

  const storedType = localStorage.getItem("type");



  const handleBottom = (value) => {
    // console.log(initialStart, "initialStart");
    // console.log(highLightBtn, "highLightBtn");
    const newValue = (highLightBtn === value ? initialStart : value);

    setHighLightBtn(newValue);
    localStorage.setItem("highlightedButton", newValue);
  };


  useEffect(() => {
    // console.log(initialStart, "initialStart2")

    setCheckType(
      highLightBtn === "UnitPlanning"
        ? "unit"
        : highLightBtn === "LessonPlanning"
          ? "lesson"
          : highLightBtn === "Assessment"
            ? "assessment"
            : highLightBtn === "LearningSupports"
              ? "learningSupports"
              : storedType
                ? storedType
                : ""
    );

    setType(
      highLightBtn === "UnitPlanning"
        ? "unit"
        : highLightBtn === "LessonPlanning"
          ? "lesson"
          : highLightBtn === "Assessment"
            ? "assessment"
            : highLightBtn === "LearningSupports"
              ? "learningSupports"
              : initialStart === "tft"
                ? "tft"
                : initialStart === "tftc"
                  ? "tftc"
                  : storedType
                    ? storedType
                    : ""


    )
  }, [highLightBtn]);




  useEffect(() => {
    setCheckType(
      initialStart === "UnitPlanning"
        ? "unit"
        : initialStart === "LessonPlanning"
          ? "lesson"
          : initialStart === "Assessment"
            ? "assessment"
            : initialStart === "LearningSupports"
              ? "learningSupports"
              : initialStart === "tft"
                ? "tft"
                : initialStart === "tftc"
                  ? "tftc"
                  : storedType
                    ? storedType
                    : ""
    );
  }, [initialStart, storedType]);


  const findLastAssistantMessageIndex = (messages) => {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      if (messages[i]?.sender === "assistant") return i;
    }
    return -1;
  };

  const findFinalPlanMessageIndex = (messages) => {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      if (messages[i]?.sender === "assistant" && isFinalPlanMessage(messages[i].message)) {
        return i;
      }
    }
    return -1;
  };

  const syncFinalPlanMessageIndex = () => {
    setAllMessage((prev) => {
      const idx = findLastAssistantMessageIndex(prev);
      if (idx !== -1) setFinalPlanMessageIndex(idx);
      return prev;
    });
  };

  const findFinalPlanInMessages = (messages) => {
    const idx = findFinalPlanMessageIndex(messages);
    if (idx === -1) return null;
    return messages[idx]?.message || null;
  };

  const getCleanPlanOutput = () => {
    const raw =
      planDocMeta?.finalOutput ||
      findFinalPlanInMessages(allMessage) ||
      "";
    return stripDocSeparatorLines(raw);
  };

  const handlePlanDocFromResponse = (apiResult, conversationId) => {
    if (!apiResult?.isFinalPlan) return;
    const meta = {
      finalOutput: stripDocSeparatorLines(apiResult.finalOutput || apiResult.response),
      planType: apiResult.planType || type,
      documentBase64: apiResult.documentBase64 || null,
      documentFilename: apiResult.documentFilename || "plan.docx",
      documentLink: apiResult.documentLink || apiResult.documentFilename,
      googleDocsLink: apiResult.googleDocsLink || null,
    };
    setPlanDocMeta(meta);
    planDocShownRef.current = true;
    setPlanDocReady(true);
    syncFinalPlanMessageIndex();
    if (conversationId) {
      savePlanDocToSession(conversationId, meta);
    }
  };

  const handleDownloadPlan = async () => {
    if (!planDocMeta) return;
    const cleanedOutput = getCleanPlanOutput();
    if (!cleanedOutput.trim()) {
      toast.error("No plan content to download");
      return;
    }
    try {
      const data = await fetchPlanDocxFromText(
        cleanedOutput,
        planDocMeta.planType || type
      );
      const meta = {
        ...planDocMeta,
        finalOutput: cleanedOutput,
        documentBase64: data.document_base64,
        documentFilename: data.document_filename,
        documentLink: data.document_link || data.document_filename,
      };
      setPlanDocMeta(meta);
      const convId = titleId || id;
      if (convId) savePlanDocToSession(convId, meta);
      downloadPlanDocxFromBase64(data.document_base64, data.document_filename);
    } catch (error) {
      toast.error("Could not generate document for download");
    }
  };

  const handleSaveToGoogleDocs = () => {
    confirmGoogleSave();
  };

  const handleOpenPlanDoc = async () => {
    if (!planDocMeta) return;

    if (planDocMeta.googleDocsLink) {
      window.open(planDocMeta.googleDocsLink, "_blank", "noopener,noreferrer");
      return;
    }

    const link = await confirmGoogleSave({ silent: true });
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  const confirmGoogleSave = async ({ silent = false } = {}) => {
    if (!planDocMeta) return null;
    if (!isGoogleDriveClientConfigured()) {
      toast.error("Google Client ID is not configured in frontend");
      return null;
    }

    setGoogleSaving(true);
    try {
      const cleanedOutput = getCleanPlanOutput();
      if (!cleanedOutput.trim()) {
        toast.error("No plan content to save");
        return null;
      }
      const data = await fetchPlanDocxFromText(
        cleanedOutput,
        planDocMeta.planType || type
      );
      const base64 = data.document_base64;
      const filename = data.document_filename;

      const accessToken = await ensureGoogleDriveAccessToken();
      const result = await uploadDocxToGoogleDrive({
        accessToken,
        documentBase64: base64,
        filename,
      });

      const meta = {
        ...planDocMeta,
        finalOutput: cleanedOutput,
        documentBase64: base64,
        documentFilename: filename,
        googleDocsLink: result.google_docs_link,
        documentLink: result.document_link || result.google_docs_link,
      };
      setPlanDocMeta(meta);
      const convId = titleId || id;
      if (convId) savePlanDocToSession(convId, meta);

      const status = getGoogleDriveClientStatus();
      setGoogleDriveConnected(Boolean(status.connected));
      setGoogleDriveEmail(status.email || "");
      if (!silent) {
        toast.success("Saved to Google Docs!");
      }
      return result.google_docs_link;
    } catch (error) {
      const errMsg = error?.message || "";
      const userCancelled = /cancel|denied|popup|closed|timed out/i.test(errMsg);
      if (!userCancelled) {
        toast.error(errMsg || "Could not save to Google Docs");
      }
      return null;
    } finally {
      setGoogleSaving(false);
    }
  };

  const getAllmessage = async (message, attachedFiles, conversationIdOverride) => {
    const conversationId = conversationIdOverride ?? titleId;
    console.log(attachedFiles, "attachedFiles 771234")
    const userMessage = { message, sender: "user", attachedFiles: attachedFiles || [] };
    setAllMessage((prev) => [...prev, userMessage]);
    if (attachedFiles && attachedFiles.length > 0) {
      setAllAttachments(prev => [...prev, ...attachedFiles]);
      console.log("All attachments updated:", [...allAttachments, ...attachedFiles]);
    }


    if (!conversationId) {
      InitializeConversationHistory(message, message, userId,schoolType);
    }

    let streamedResponse = "";
    setIsStreamingResponse(true);
    setPlanDocReady(false);

    await christianEducation(message, allMessage, predefinedAnswers, type, attachedFiles, allAttachments, (chunk) => {
      streamedResponse += chunk;
      setBotTyping(false);  // Show typing or loader

      // Show streamed response live
      setAllMessage((prev) => {
        const updated = [...prev];
        const last = updated[updated.length - 1];
        if (last?.sender === "assistant") {
          updated[updated.length - 1] = { message: streamedResponse, sender: "assistant" };
        } else {
          updated.push({ message: streamedResponse, sender: "assistant" });
        }
        return updated;
      });
    })
      .then((apiResult) => {
        setIsStreamingResponse(false);
        handlePlanDocFromResponse(apiResult, conversationId);
        const messagesToSave = [
          { conversation_id: conversationId, sender: "user", message },
          { conversation_id: conversationId, sender: "assistant", message: streamedResponse }
        ];
        return SaveConversationHistory(messagesToSave);
      })
      .catch((err) => {
        console.error("❌ Error in sendMessage or SaveChatMessages:", err);
      }).finally(() => {

      // Cleanup UI states
      setBotTyping(false);
      setIsStreamingResponse(false);
      // If you have loader: setChatLoading(false)
      // If you want to stop reload: setStopReload(false);
    });
  };

  

  const AllbuttomMessage = async (message, buttonType) => {
    alert("AllbuttomMessage called")
    setBotTyping(true)
    const userMessage = { message, sender: "user" };
    setAllMessage((prev) => [...prev, userMessage]);

    

    let streamedResponse = "";
    setIsStreamingResponse(true);
    setPlanDocReady(false);

    await christianEducation(message, allMessage, predefinedAnswers, buttonType, (chunk) => {
      streamedResponse += chunk;
      setBotTyping(false);  // Show typing or loader
      
      // Show streamed response live
      setAllMessage((prev) => {
        const updated = [...prev];
        const last = updated[updated.length - 1];
        if (last?.sender === "assistant") {
          updated[updated.length - 1] = { message: streamedResponse, sender: "assistant" };
        } else {
          updated.push({ message: streamedResponse, sender: "assistant" });
        }
        return updated;
      });
    })
      .then((apiResult) => {
        setIsStreamingResponse(false);
        handlePlanDocFromResponse(apiResult, titleId);
        const messagesToSave = [
          { conversation_id: titleId, sender: "user", message },
          { conversation_id: titleId, sender: "assistant", message: streamedResponse }
        ];
        return SaveConversationHistory(messagesToSave);
      })
      .catch((err) => {
        console.error("❌ Error in sendMessage or SaveChatMessages:", err);
      }).finally(() => {
    // ⭐ Anything you want to always run
    // console.log("✨ Finished christianEducation & message save flow");

    // Example: stop typing indicator
    setBotTyping(false);
    setIsStreamingResponse(false);

    // Example: cleanup
    // setLoading(false);
  });
  };



  const initializeChat = async (message, attachedFilesParam = []) => {
    // console.log(message, "message in initializeChat")
    
    setChatLoading(true);
    setBotTyping(true);  // Show typing indicator (e.g. TFT first chat)
    setStopReload(false)
    if (!titleId) {
      initInProgressRef.current = true;
      try {
        // console.log(message, "message in initializeChat");
        // console.log(predefinedAnswers, "predefinedAnswers in initializeChat");

        const filesToUse = attachedFilesParam || [];
        setAllMessage((prev) => [
          ...prev,
          { sender: "user", message: message || "", attachedFiles: filesToUse },
        ]);
        if (filesToUse.length > 0) {
          setAllAttachments(prev => [...prev, ...filesToUse]);
        }
        let streamedResponse = "";
        let botMessageIndex = -1;
        const allAttachmentsForApi = filesToUse;
        setIsStreamingResponse(true);
        setPlanDocReady(false);

        const res = await christianEducation(
          message || "",
          allMessage,
          predefinedAnswers,
          type,
          filesToUse,
          allAttachmentsForApi,

          (chunk) => {
            streamedResponse += chunk;
            setChatLoading(false);
            setBotTyping(false);  // Hide typing once stream starts

            setAllMessage((prev) => {
              const updated = [...prev];
              if (botMessageIndex === -1) {
                botMessageIndex = updated.length;
                updated.push({ sender: "assistant", message: streamedResponse });
              } else {
                updated[botMessageIndex] = { sender: "assistant", message: streamedResponse };
              }
              return updated;
            });
          }
        );

        const response = await InitializeConversationHistory("testing one two", initialStart, userId);
        const newConversationId = response.data.id;

        setIsStreamingResponse(false);
        handlePlanDocFromResponse(res, newConversationId);

        const botMessageStart = streamedResponse || res.response || 'Hi! Ready to get started.';

        const messagesToSave = [
          {
            conversation_id: newConversationId,
            sender: "user",
            message: message,
          },
          {
            conversation_id: newConversationId,
            sender: "assistant",
            message: botMessageStart,
          },
        ];

        // console.log(messagesToSave, "messagesToSave in initializeChat");
        await SaveConversationHistory(messagesToSave);

        const last20Titles = (conversationHistory || []).slice(0, 20).map((c) => c?.title).filter(Boolean);
        const fromLearningSupports = location.state?.fromLearningSupports === true;
        const newtitle = fromLearningSupports
          ? buildLearningSupportSidebarTitle(predefinedAnswers)
          : await generateTitle(botMessageStart, predefinedAnswers, last20Titles, { fromLearningSupports: false });

        TitleUpdate(newConversationId, userId, newtitle)
          .finally(() => {
            setTitleId(newConversationId);
            setSidelistUpdate(newConversationId + 1);
            window.history.replaceState(null, "", `/afterchatbot?id=${newConversationId}`);
          });
       setBotTyping(false);


        setChatLoading(false);
        return true;

      } catch (error) {
        console.error("❌ Error in InitializeConversationHistory chain:", error);
        return false;
      } finally {
      // ⭐ Always execute (success OR error)
      // console.log("✨ Cleanup running in finally()");
      initInProgressRef.current = false;
      setBotTyping(false);
      setChatLoading(false);
      setStopReload(false);
      setIsStreamingResponse(false);
    }
    }

    return false;
  };



  const handleSend = (attachedFiles) => {
    // alert("hi111 ")
    console.log(attachedFiles, "attachedFiles 122")
    setVisibleMsgBox(true);
    setBotTyping(true);  // Show typing or loader

    const hasText = message.trim() !== "";
    const hasAttachments = attachedFiles && attachedFiles.length > 0;
    if (!hasText && !hasAttachments) return;

    const textToSend = message.trim() || "";
    setMessage("");

    // Shared link (URL me id hai): pehle copy API, phir nayi conversation me message save
    if (isSharedLink) {
      setBotTyping(true);
      copyData(Number(id), userId)
        .then((res) => {
          const newId = res?.data?.id ?? res?.data?.conversation_id ?? res?.data?.new_conversation_id;
          const targetId = newId || id;
          setTitleId(targetId);
          sessionStorage.setItem("titleId", String(targetId));
          setSidelistUpdate(Number(targetId) + 1);
          return getAllmessage(textToSend, attachedFiles, targetId).then(() => targetId);
        })
        .then((targetId) => {
          setBotTyping(false);
          if (targetId) window.history.replaceState(null, "", `/afterchatbot?id=${targetId}`);
        })
        .catch((err) => {
          console.error("Copy API error:", err);
          setBotTyping(false);
        });
      return;
    }

    if (titleId) {
      Promise.resolve(getAllmessage(textToSend, attachedFiles))
        .finally(() => setBotTyping(false));
    } else if (initInProgressRef.current || chatLoading) {
      toast.info("Please wait, your chat is still starting...");
      setBotTyping(false);
    } else {
      initializeChat(textToSend, attachedFiles);
    }
  };


  useEffect(() => {
    // 1 = Reload
    // const savedTitleId = localStorage.getItem("titleId");

    const savedTitleId = sessionStorage.getItem("titleId");
    // alert(savedTitleId,"savedTitleId")
    if (savedTitleId) {
      setTitleId(savedTitleId);
    }

  }, []);



  useEffect(() => {
    if (titleId) {
      if (!id) {
        // alert("hi111")
        // localStorage.setItem("titleId", titleId);
        sessionStorage.setItem("titleId", titleId);
        setChatLoading(true)
        setLoaderText(false)
        const fetchConversation = async () => {
          try {
            await GetConversationHistory(titleId, setAllMessage);
          } catch (error) {
            console.error("Failed to fetch conversation history:", error);
          } finally {
            setChatLoading(false); // Set false after success or failure
            if (!fromTFT) setLoaderText(true)
          }
        };
        
        if (stopReload) {

          fetchConversation();

        }
        else {
          setChatLoading(false); // Set false after success or failure
          if (!fromTFT) setLoaderText(true)
          setStopReload(true)
        }


      }
    }
    setAllAttachments([]);
console.log(titleId,"titleIdfromuseeffect")
  }, [titleId])


  const isMasterTypeMismatch = id && linkMasterTypeId !== null && linkMasterTypeId !== "" && currentUserMasterTypeId !== "" && String(linkMasterTypeId) !== String(currentUserMasterTypeId);

  useEffect(() => {
    if (isMasterTypeMismatch) {
      alert("This chat was shared from a different school type. You can only view chats shared within your school type.");
      navigate("/", { replace: true });
      return;
    }
  }, [isMasterTypeMismatch, navigate]);

  useEffect(() => {
    if (id && !isMasterTypeMismatch) {
      localStorage.setItem("testing id", id);

      setChatLoading(true)
      const fetchConversation = async () => {
        try {
          await GetConversationHistory(id, setAllMessage, historySize);

        } catch (error) {
          console.error("Failed to fetch conversation history:", error);
        } finally {
          setChatLoading(false); // Set false after success or failure
        }
      };
      fetchConversation();
    }
  }, [id, isMasterTypeMismatch])


  const [editingIndex, setEditingIndex] = useState(null);
  const [editedMessage, setEditedMessage] = useState("");
  const handleEditClick = (index, msg) => {
    setEditingIndex(index);
    setEditedMessage(msg.message);
  };

  const handleSaveClick = async (msg, index) => {
    try {
      await MessageUpdate(msg.id, msg.conversation_id, msg.sender, editedMessage);
      const updatedMessages = [...allMessage];
      updatedMessages[index].message = editedMessage;
      setAllMessage(updatedMessages);
      setEditingIndex(null);

      const editedIsPlan =
        msg?.sender === "assistant" &&
        (isFinalPlanMessage(editedMessage) ||
          (planDocShownRef.current && index === finalPlanMessageIndex));

      if (editedIsPlan) {
        const cleaned = stripDocSeparatorLines(editedMessage);
        const convId = titleId || id;
        setFinalPlanMessageIndex(index);
        setPlanDocMeta((prev) => {
          const next = {
            ...(prev || {}),
            finalOutput: cleaned,
            planType: prev?.planType || type,
          };
          if (convId) savePlanDocToSession(convId, next);
          return next;
        });
        planDocShownRef.current = true;
        setPlanDocReady(true);
      }
    } catch (error) {
      console.error("Failed to update message:", error);
    }
  };
  
  
  // let messageTft =0

  // useEffect(() => {
  //   if (location?.state?.input) {
  //     if(messageTft==0){
  //       messageTft=1
  //       // const formatedata = formatAnswersAsPlainText(location.state.input, location.state.input);
  //       const formatedata = {
  //         [location?.state?.input]: location?.state?.input
  //       };        
  //       // console.log(formatedata, "formatedata 12211")
  //       initializeChat(location?.state?.input)
  //     }
  //     // getAllmessage(location.state.input);
  //   }
  // }, []); // e

//===========================================

  const blockedRef2 = useRef(false);

  useEffect(() => {
    if (titleId) {
      blockedRef2.current = true;
    }


    setTimeout(() => {
      if (!blockedRef.current && location?.state?.input) {
        initializeChat(location?.state?.input)
        
      }
    }, 0);


  }, []);

  useEffect(() => {
    if (titleId) {
      blockedRef2.current = true;
    }
  }, [titleId]);







//===========================================









  const blockedRef = useRef(false);

  useEffect(() => {
    if (titleId) {
      blockedRef.current = true;
    }


    const predefinedformatedata = location.state?.formatedata || {};
    // console.log(predefinedformatedata, "predefinedformatedata")
    setTimeout(() => {
      if (!blockedRef.current && predefinedformatedata) {
        if (predefinedformatedata && predefinedformatedata.length > 0) {
          // alert("hi111")
          initializeChat(predefinedformatedata);
        }
        // else{
        //   navigate("/") // bcz share  functionality will  not work 


        // }
      }
    }, 0);


  }, []);

  useEffect(() => {
    if (titleId) {
      blockedRef.current = true;
    }
  }, [titleId]);



  useEffect(() => {
    const valuetype = localStorage.getItem("type")

    const finalType = initialStart === "UnitPlanning" ? "unit"
      : initialStart === "LessonPlanning" ? "lesson"
        : initialStart === "Assessment" ? "assessment"
          : initialStart === "LearningSupports" ? "learningSupports"
            : types ? types : valuetype ? valuetype : "";

    setType(finalType);
    setCheckType(finalType);

    localStorage.setItem("type", finalType);
  }, [initialStart]);

  useEffect(() => {
    const valuetype = localStorage.getItem("type")
    if (valuetype) {
      setType(valuetype);
      setCheckType(valuetype);
    }

  }, [localStorage.getItem("type")])

  useEffect(() => {
    setCheckType(type)
  }, [type])


  useEffect(() => {
    setShareSize(allMessage.length)
  }, [allMessage])

  useEffect(() => {
    const convId = titleId || id || null;
    if (convId === prevConversationIdRef.current) return;
    prevConversationIdRef.current = convId;

    planDocShownRef.current = false;
    setPlanDocMeta(null);
    setPlanDocReady(false);
    setFinalPlanMessageIndex(-1);
    setIsStreamingResponse(false);

    if (!convId) return;

    const cached = loadPlanDocFromSession(convId);
    if (!cached) return;

    planDocShownRef.current = true;
    setPlanDocMeta(cached);
    setPlanDocReady(true);
  }, [titleId, id]);

  useEffect(() => {
    const idx = findFinalPlanMessageIndex(allMessage);
    if (idx === -1) {
      if (planDocShownRef.current) {
        const lastAssistantIdx = findLastAssistantMessageIndex(allMessage);
        if (lastAssistantIdx !== -1) {
          setFinalPlanMessageIndex(lastAssistantIdx);
          if (!isStreamingResponse) setPlanDocReady(true);
        }
        return;
      }
      setPlanDocReady(false);
      setFinalPlanMessageIndex(-1);
      return;
    }

    setFinalPlanMessageIndex(idx);

    if (isStreamingResponse) {
      setPlanDocReady(false);
      return;
    }

    if (planDocShownRef.current) {
      setPlanDocReady(true);
      return;
    }

    const convId = titleId || id;
    const finalText = allMessage[idx]?.message;
    if (!finalText) return;

    const cached = convId ? loadPlanDocFromSession(convId) : null;
    if (cached) {
      setPlanDocMeta({
        ...cached,
        finalOutput: stripDocSeparatorLines(cached.finalOutput || finalText),
      });
    } else {
      setPlanDocMeta({ finalOutput: stripDocSeparatorLines(finalText), planType: type });
    }
    planDocShownRef.current = true;
    setPlanDocReady(true);
  }, [allMessage, titleId, id, type, isStreamingResponse]);

  useEffect(() => {
    const status = getGoogleDriveClientStatus();
    setGoogleDriveConnected(Boolean(status.connected));
    setGoogleDriveEmail(status.email || "");
  }, []);

  const showEmptyStateForId = !!(id && !chatLoading && allMessage.length === 0);

  return (

    <OuterPage
      AllbuttomMessage={AllbuttomMessage}
      fromTFT={fromTFT}
      loaderText={loaderText}
      allMessage={allMessage}
      BotTyping={BotTyping}
      message={message}
      setMessage={setMessage}
      handleSend={handleSend}
      visibleMsgBox={visibleMsgBox}
      editingIndex={editingIndex}
      editedMessage={editedMessage}
      setEditedMessage={setEditedMessage}
      handleEditClick={handleEditClick}
      handleSaveClick={handleSaveClick}
      setEditingIndex={setEditingIndex}
      initializeChat={initializeChat}
      chatLoading={chatLoading}
      highLightBtn={highLightBtn}
      handleBottom={handleBottom}
      showEmptyStateForId={showEmptyStateForId}
      emptyStateId={id}
      planDocReady={planDocReady}
      planDocMeta={planDocMeta}
      finalPlanMessageIndex={finalPlanMessageIndex}
      isStreamingResponse={isStreamingResponse}
      onDownloadPlan={handleDownloadPlan}
      onSaveToGoogleDocs={handleSaveToGoogleDocs}
      onOpenPlanDoc={handleOpenPlanDoc}
      googleSaving={googleSaving}
      googleDriveConnected={googleDriveConnected}
      googleDriveEmail={googleDriveEmail}
    />
  );
};

export default AfterChatbot;
